import { extendTheme, ThemeConfig } from "@chakra-ui/react";

// Color configuration for light/dark mode
const config: ThemeConfig = {
  initialColorMode: "light",
  useSystemColorMode: false,
};

// Passport-inspired color palette
const colors = {
  primary: {
    // Navy blue (passport cover)
    50: "#e6eaf2",
    100: "#ccd6e5",
    200: "#99add0",
    300: "#6685bc",
    400: "#335ca7",
    500: "#003399", // Primary navy
    600: "#002d80",
    700: "#002766",
    800: "#00214d",
    900: "#001b33",
  },
  secondary: {
    // Burgundy/maroon (alternate passport color)
    50: "#f9e6ed",
    100: "#f3ccdb",
    200: "#e799b7",
    300: "#db6694",
    400: "#cf3370",
    500: "#990033", // Primary burgundy
    600: "#8c002e",
    700: "#800029",
    800: "#730024",
    900: "#66001f",
  },
  accent: {
    // Gold/metallic (passport emblem/text)
    50: "#fdf8e6",
    100: "#faefc0",
    200: "#f7e699",
    300: "#f5dd73",
    400: "#f2d44c",
    500: "#d4af37", // Primary gold
    600: "#aa8c2c",
    700: "#7f6921",
    800: "#554616",
    900: "#2a230b",
  },
  background: {
    // Cream/paper (passport pages)
    50: "#fefefe",
    100: "#f9f8f5",
    200: "#f4f1eb",
    300: "#efeae0",
    400: "#e9e3d6",
    500: "#e4dccb", // Primary cream
    600: "#d6cbb3",
    700: "#c8ba9c",
    800: "#b9a984",
    900: "#ab986d",
  },
};

// Component-specific theme customization
const components = {
  Button: {
    baseStyle: {
      fontWeight: "500",
    },
    variants: {
      solid: (props: { colorScheme: string }) => ({
        bg: `${props.colorScheme}.500`,
        color: props.colorScheme === "background" ? "gray.800" : "white",
        _hover: {
          bg: `${props.colorScheme}.600`,
        },
      }),
      outline: (props: { colorScheme: string }) => ({
        borderColor: `${props.colorScheme}.500`,
        color: `${props.colorScheme}.500`,
        _hover: {
          bg: `${props.colorScheme}.50`,
        },
      }),
    },
    defaultProps: {
      colorScheme: "primary",
    },
  },
  Card: {
    baseStyle: {
      container: {
        bg: "background.50",
        borderColor: "background.200",
      },
      header: {
        paddingBottom: "2",
      },
      body: {
        paddingTop: "2",
      },
    },
  },
  Heading: {
    baseStyle: {
      color: "primary.700",
      fontWeight: "600",
    },
  },
};

// Global style overrides
const styles = {
  global: {
    body: {
      bg: "background.100",
      color: "gray.800",
    },
  },
};

// Create the extended theme
const theme = extendTheme({
  config,
  colors,
  components,
  styles,
});

export default theme;
